export default function() {
    return [{
        title: 'Main Navigation',
        htmlBefore: '<i class="material-icons">&#xE2C7;</i>',
        items: [{
            title: 'Dashboard',
            to: {
                name: 'Dashboard',
            },
        }, {
            title: 'Store',
            to: {
                name: 'ecommerce',
            },
        }, {
            title: 'Blog',
            to: {
                name: 'blog-overview',
            },
        }],
    }, {
        title: 'Header Nav',
        htmlBefore: '<i class="material-icons">view_day</i>',
        to: {
            name: 'header-navigation',
        },
    }, {
        title: 'Icon Sidebar',
        htmlBefore: '<i class="material-icons">&#xE251;</i>',
        to: {
            name: 'icon-sidebar-nav',
        },
    }, {
        title: 'Components',
        htmlBefore: '<i class="material-icons">view_module</i>',
        items: [{
            title: 'Overview',
            to: {
                name: 'components-overview',
            },
        }, {
            title: 'Blog Posts',
            to: {
                name: 'blog-posts',
            },
        }],
    }, {
        title: 'File Managers',
        htmlBefore: '<i class="material-icons">&#xE2C7;</i>',
        items: [{
            title: 'File Manager - List',
            to: {
                name: 'advertisers',
            },
        }, {
            title: 'File Manager - Cards',
            to: {
                name: 'medias',
            },
        }],
    }, {
        title: 'Transactions',
        htmlBefore: '<i class="material-icons"></i>',
        to: {
            name: 'transactions',
        },
    }, {
        title: 'User Account',
        htmlBefore: '<i class="material-icons">&#xE8B9;</i>',
        items: [{
            title: 'User Profile',
            to: {
                name: 'user-profile',
            },
        }, {
            title: 'Edit User Profile',
            to: {
                name: 'edit-user-profile',
            },
        }, {
            title: 'Register',
            to: {
                name: 'register',
            },
        }, {
            title: 'Forgot Password',
            to: {
                name: 'forgot-password',
            },
        }, {
            title: 'Reset Password',
            to: {
                name: 'reset-password',
            },
        }],
    }, {
        title: 'help',
        htmlBefore: '<i class="material-icons">error</i>',
        to: {
            name: 'help',
        },
    }];
}
